module.exports = __webpack_public_path__ + "img/sym.4f40799a.png";